import styled from 'styled-components'
import { Pill } from '@components/Pill'

export const TagPillEl = styled(Pill)``
